var exports = {
  "zr": "root__EjI4rV",
  "bl": "prErrorBanner__rL9bZU",
  "kL": "container__9EbSs7",
  "pq": "info__9k3bMd",
  "Rm": "toggleButton__nPx2ah",
  "Kk": "icon__SEyD2X",
  "tk": "branch__OZsr-N",
  "Ot": "branchText__1H9Jrb",
  "a3": "branchCopyFocusVisible__DsVlds",
  "nJ": "copyIcon__OA8SHY",
  "o1": "actions__dds_uL",
  "zt": "diffContainer__Ydj5Zx",
  "iV": "diffList__boYDv0",
  "Jy": "diffItem__DZMyFL",
  "XE": "fileInfo__TAvZe_",
  "Md": "fileName__e1dQky",
  "I_": "fileDirectory__qmXJj2",
  "h1": "fileAdded__F3TP-W",
  "Ww": "fileDeleted__f-oLSA",
  "J8": "fileChanged__FLdtHX",
  "mv": "additions__6O-dhE",
  "uS": "deletions__cLOOug",
};

module.exports = exports;
